import {
  ABEL,
  CELIA_YUNIOR,
  CENSURA,
  CONTEXTO,
  CRISTINA,
  FIDEL_GARCIA,
  FORMACION,
  FULL_ABEL,
  FULL_CELIA_YUNIOR,
  FULL_CRISTINA,
  FULL_FIDEL_GARCIA,
  FULL_HENRI_ERIC,
  FULL_HUMBERTO_DIAZ,
  FULL_JAVIER_CASTRO,
  FULL_JORGE_RODRIGUEZ,
  FULL_LUIS_MANUEL,
  FULL_MAGALY_ESPINOSA,
  FULL_MOSQUERA,
  FULL_NESTOR,
  FULL_REYNIER_LEYVA,
  FULL_RODOLFO_PERAZA,
  FULL_SANDRA_CEBALLOS,
  FULL_SANDRA_RAMOS,
  FULL_TANYA,
  FULL_TOIRAC,
  FULL_YANELIS,
  HENRI_ERIC,
  HUMBERTO_DIAZ,
  JAVIER_CASTRO,
  JORGE_RODRIGUEZ,
  LUIS_MANUEL,
  MAGALY_ESPINOSA,
  MERCADO,
  MOSQUERA,
  NESTOR,
  OBRA,
  REYNIER_LEYVA,
  RODOLFO_PERAZA,
  SANDRA_CEBALLOS,
  SANDRA_RAMOS,
  TANYA,
  TOIRAC,
  YANELIS,
} from '../constants';

const data = [
  {
    id: 1,
    category: CENSURA,
    artist: CELIA_YUNIOR,
    artistFull: FULL_CELIA_YUNIOR,
    images: {
      large: `/images/large/${CENSURA}-${CELIA_YUNIOR}.jpg`,
      medium: `/images/medium/${CENSURA}-${CELIA_YUNIOR}.jpg`,
      small: `/images/small/${CENSURA}-${CELIA_YUNIOR}.jpg`,
    },
    posX: 2809.583,
    posY: 1495.961,
    video: `/videos/${CENSURA}-${CELIA_YUNIOR}`,
  },
  {
    id: 2,
    category: CENSURA,
    artist: CRISTINA,
    artistFull: FULL_CRISTINA,
    images: {
      large: `/images/large/${CENSURA}-${CRISTINA}.jpg`,
      medium: `/images/medium/${CENSURA}-${CRISTINA}.jpg`,
      small: `/images/small/${CENSURA}-${CRISTINA}.jpg`,
    },
    posX: 1016.779,
    posY: 1053.568,
    video: `/videos/${CENSURA}-${CRISTINA}`,
  },
  {
    id: 3,
    category: CENSURA,
    artist: FIDEL_GARCIA,
    artistFull: FULL_FIDEL_GARCIA,
    images: {
      large: `/images/large/${CENSURA}-${FIDEL_GARCIA}.jpg`,
      medium: `/images/medium/${CENSURA}-${FIDEL_GARCIA}.jpg`,
      small: `/images/small/${CENSURA}-${FIDEL_GARCIA}.jpg`,
    },
    posX: 1190.598,
    posY: 939.733,
    video: `/videos/${CENSURA}-${FIDEL_GARCIA}`,
  },
  {
    id: 4,
    category: CENSURA,
    artist: HENRI_ERIC,
    artistFull: FULL_HENRI_ERIC,
    images: {
      large: `/images/large/${CENSURA}-${HENRI_ERIC}.jpg`,
      medium: `/images/medium/${CENSURA}-${HENRI_ERIC}.jpg`,
      small: `/images/small/${CENSURA}-${HENRI_ERIC}.jpg`,
    },
    posX: 2337.702,
    posY: 1429.281,
    video: `/videos/${CENSURA}-${HENRI_ERIC}`,
  },
  {
    id: 5,
    category: CENSURA,
    artist: HUMBERTO_DIAZ,
    artistFull: FULL_HUMBERTO_DIAZ,
    images: {
      large: `/images/large/${CENSURA}-${HUMBERTO_DIAZ}.jpg`,
      medium: `/images/medium/${CENSURA}-${HUMBERTO_DIAZ}.jpg`,
      small: `/images/small/${CENSURA}-${HUMBERTO_DIAZ}.jpg`,
    },
    posX: 1890.403,
    posY: 1058.018,
    video: `/videos/${CENSURA}-${HUMBERTO_DIAZ}`,
  },
  {
    id: 6,
    category: CENSURA,
    artist: LUIS_MANUEL,
    artistFull: FULL_LUIS_MANUEL,
    images: {
      large: `/images/large/${CENSURA}-${LUIS_MANUEL}.jpg`,
      medium: `/images/medium/${CENSURA}-${LUIS_MANUEL}.jpg`,
      small: `/images/small/${CENSURA}-${LUIS_MANUEL}.jpg`,
    },
    posX: 895.65,
    posY: 963.074,
    video: `/videos/${CENSURA}-${LUIS_MANUEL}`,
  },
  {
    id: 7,
    category: CENSURA,
    artist: MAGALY_ESPINOSA,
    artistFull: FULL_MAGALY_ESPINOSA,
    images: {
      large: `/images/large/${CENSURA}-${MAGALY_ESPINOSA}.jpg`,
      medium: `/images/medium/${CENSURA}-${MAGALY_ESPINOSA}.jpg`,
      small: `/images/small/${CENSURA}-${MAGALY_ESPINOSA}.jpg`,
    },
    posX: 1733.094,
    posY: 863.906,
    video: `/videos/${CENSURA}-${MAGALY_ESPINOSA}`,
  },
  {
    id: 8,
    category: CENSURA,
    artist: MOSQUERA,
    artistFull: FULL_MOSQUERA,
    images: {
      large: `/images/large/${CENSURA}-${MOSQUERA}.jpg`,
      medium: `/images/medium/${CENSURA}-${MOSQUERA}.jpg`,
      small: `/images/small/${CENSURA}-${MOSQUERA}.jpg`,
    },
    posX: 2516.41,
    posY: 1251.026,
    video: `/videos/${CENSURA}-${MOSQUERA}`,
  },
  {
    id: 9,
    category: CENSURA,
    artist: NESTOR,
    artistFull: FULL_NESTOR,
    images: {
      large: `/images/large/${CENSURA}-${NESTOR}.jpg`,
      medium: `/images/medium/${CENSURA}-${NESTOR}.jpg`,
      small: `/images/small/${CENSURA}-${NESTOR}.jpg`,
    },
    posX: 1558.037,
    posY: 871.54,
    video: `/videos/${CENSURA}-${NESTOR}`,
  },
  {
    id: 10,
    category: CENSURA,
    artist: REYNIER_LEYVA,
    artistFull: FULL_REYNIER_LEYVA,
    images: {
      large: `/images/large/${CENSURA}-${REYNIER_LEYVA}.jpg`,
      medium: `/images/medium/${CENSURA}-${REYNIER_LEYVA}.jpg`,
      small: `/images/small/${CENSURA}-${REYNIER_LEYVA}.jpg`,
    },
    posX: 2300.906,
    posY: 1259.065,
    video: `/videos/${CENSURA}-${REYNIER_LEYVA}`,
  },
  {
    id: 11,
    category: CENSURA,
    artist: SANDRA_CEBALLOS,
    artistFull: FULL_SANDRA_CEBALLOS,
    images: {
      large: `/images/large/${CENSURA}-${SANDRA_CEBALLOS}.jpg`,
      medium: `/images/medium/${CENSURA}-${SANDRA_CEBALLOS}.jpg`,
      small: `/images/small/${CENSURA}-${SANDRA_CEBALLOS}.jpg`,
    },
    posX: 2556.294,
    posY: 1423.745,
    video: `/videos/${CENSURA}-${SANDRA_CEBALLOS}`,
  },
  {
    id: 12,
    category: CENSURA,
    artist: SANDRA_RAMOS,
    artistFull: FULL_SANDRA_RAMOS,
    images: {
      large: `/images/large/${CENSURA}-${SANDRA_RAMOS}.jpg`,
      medium: `/images/medium/${CENSURA}-${SANDRA_RAMOS}.jpg`,
      small: `/images/small/${CENSURA}-${SANDRA_RAMOS}.jpg`,
    },
    posX: 909.146,
    posY: 1050.669,
    video: `/videos/${CENSURA}-${SANDRA_RAMOS}`,
  },
  {
    id: 13,
    category: CENSURA,
    artist: TANYA,
    artistFull: FULL_TANYA,
    images: {
      large: `/images/large/${CENSURA}-${TANYA}.jpg`,
      medium: `/images/medium/${CENSURA}-${TANYA}.jpg`,
      small: `/images/small/${CENSURA}-${TANYA}.jpg`,
    },
    posX: 1503.905,
    posY: 991.424,
    video: `/videos/${CENSURA}-${TANYA}`,
  },
  {
    id: 14,
    category: CENSURA,
    artist: TOIRAC,
    artistFull: FULL_TOIRAC,
    images: {
      large: `/images/large/${CENSURA}-${TOIRAC}.jpg`,
      medium: `/images/medium/${CENSURA}-${TOIRAC}.jpg`,
      small: `/images/small/${CENSURA}-${TOIRAC}.jpg`,
    },
    posX: 1838.897,
    posY: 998.483,
    video: `/videos/${CENSURA}-${TOIRAC}`,
  },
  {
    id: 15,
    category: CENSURA,
    artist: YANELIS,
    artistFull: FULL_YANELIS,
    images: {
      large: `/images/large/${CENSURA}-${YANELIS}.jpg`,
      medium: `/images/medium/${CENSURA}-${YANELIS}.jpg`,
      small: `/images/small/${CENSURA}-${YANELIS}.jpg`,
    },
    posX: 1464.973,
    posY: 856.188,
    video: `/videos/${CENSURA}-${YANELIS}`,
  },
  {
    id: 16,
    category: CONTEXTO,
    artist: ABEL,
    artistFull: FULL_ABEL,
    images: {
      large: `/images/large/${CONTEXTO}-${ABEL}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${ABEL}.jpg`,
      small: `/images/small/${CONTEXTO}-${ABEL}.jpg`,
    },
    posX: 1417.859,
    posY: 957.19,
    video: `/videos/${CONTEXTO}-${ABEL}`,
  },
  {
    id: 17,
    category: CONTEXTO,
    artist: CELIA_YUNIOR,
    artistFull: FULL_CELIA_YUNIOR,
    images: {
      large: `/images/large/${CONTEXTO}-${CELIA_YUNIOR}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${CELIA_YUNIOR}.jpg`,
      small: `/images/small/${CONTEXTO}-${CELIA_YUNIOR}.jpg`,
    },
    posX: 2896.003,
    posY: 1499.445,
    video: `/videos/${CONTEXTO}-${CELIA_YUNIOR}`,
  },
  {
    id: 18,
    category: CONTEXTO,
    artist: CRISTINA,
    artistFull: FULL_CRISTINA,
    images: {
      large: `/images/large/${CONTEXTO}-${CRISTINA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${CRISTINA}.jpg`,
      small: `/images/small/${CONTEXTO}-${CRISTINA}.jpg`,
    },
    posX: 1744.336,
    posY: 1085.067,
    video: `/videos/${CONTEXTO}-${CRISTINA}`,
  },
  {
    id: 19,
    category: CONTEXTO,
    artist: FIDEL_GARCIA,
    artistFull: FULL_FIDEL_GARCIA,
    images: {
      large: `/images/large/${CONTEXTO}-${FIDEL_GARCIA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${FIDEL_GARCIA}.jpg`,
      small: `/images/small/${CONTEXTO}-${FIDEL_GARCIA}.jpg`,
    },
    posX: 1923.86,
    posY: 1005.372,
    video: `/videos/${CONTEXTO}-${FIDEL_GARCIA}`,
  },
  {
    id: 20,
    category: CONTEXTO,
    artist: HENRI_ERIC,
    artistFull: FULL_HENRI_ERIC,
    images: {
      large: `/images/large/${CONTEXTO}-${HENRI_ERIC}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${HENRI_ERIC}.jpg`,
      small: `/images/small/${CONTEXTO}-${HENRI_ERIC}.jpg`,
    },
    posX: 1843.171,
    posY: 1157.783,
    video: `/videos/${CONTEXTO}-${HENRI_ERIC}`,
  },
  {
    id: 21,
    category: CONTEXTO,
    artist: HUMBERTO_DIAZ,
    artistFull: FULL_HUMBERTO_DIAZ,
    images: {
      large: `/images/large/${CONTEXTO}-${HUMBERTO_DIAZ}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${HUMBERTO_DIAZ}.jpg`,
      small: `/images/small/${CONTEXTO}-${HUMBERTO_DIAZ}.jpg`,
    },
    posX: 2268.561,
    posY: 1149.474,
    video: `/videos/${CONTEXTO}-${HUMBERTO_DIAZ}`,
  },
  {
    id: 22,
    category: CONTEXTO,
    artist: JAVIER_CASTRO,
    artistFull: FULL_JAVIER_CASTRO,
    images: {
      large: `/images/large/${CONTEXTO}-${JAVIER_CASTRO}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${JAVIER_CASTRO}.jpg`,
      small: `/images/small/${CONTEXTO}-${JAVIER_CASTRO}.jpg`,
    },
    posX: 2022.022,
    posY: 1063.502,
    video: `/videos/${CONTEXTO}-${JAVIER_CASTRO}`,
  },
  {
    id: 23,
    category: CONTEXTO,
    artist: JORGE_RODRIGUEZ,
    artistFull: FULL_JORGE_RODRIGUEZ,
    images: {
      large: `/images/large/${CONTEXTO}-${JORGE_RODRIGUEZ}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${JORGE_RODRIGUEZ}.jpg`,
      small: `/images/small/${CONTEXTO}-${JORGE_RODRIGUEZ}.jpg`,
    },
    posX: 1643.647,
    posY: 836.506,
    video: `/videos/${CONTEXTO}-${JORGE_RODRIGUEZ}`,
  },
  {
    id: 24,
    category: CONTEXTO,
    artist: LUIS_MANUEL,
    artistFull: FULL_LUIS_MANUEL,
    images: {
      large: `/images/large/${CONTEXTO}-${LUIS_MANUEL}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${LUIS_MANUEL}.jpg`,
      small: `/images/small/${CONTEXTO}-${LUIS_MANUEL}.jpg`,
    },
    posX: 1105.682,
    posY: 949.048,
    video: `/videos/${CONTEXTO}-${LUIS_MANUEL}`,
  },
  {
    id: 25,
    category: CONTEXTO,
    artist: MAGALY_ESPINOSA,
    artistFull: FULL_MAGALY_ESPINOSA,
    images: {
      large: `/images/large/${CONTEXTO}-${MAGALY_ESPINOSA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${MAGALY_ESPINOSA}.jpg`,
      small: `/images/small/${CONTEXTO}-${MAGALY_ESPINOSA}.jpg`,
    },
    posX: 1582.41,
    posY: 1022.503,
    video: `/videos/${CONTEXTO}-${MAGALY_ESPINOSA}`,
  },
  {
    id: 26,
    category: CONTEXTO,
    artist: MOSQUERA,
    artistFull: FULL_MOSQUERA,
    images: {
      large: `/images/large/${CONTEXTO}-${MOSQUERA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${MOSQUERA}.jpg`,
      small: `/images/small/${CONTEXTO}-${MOSQUERA}.jpg`,
    },
    posX: 1492.405,
    posY: 919.316,
    video: `/videos/${CONTEXTO}-${MOSQUERA}`,
  },
  {
    id: 27,
    category: CONTEXTO,
    artist: NESTOR,
    artistFull: FULL_NESTOR,
    images: {
      large: `/images/large/${CONTEXTO}-${NESTOR}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${NESTOR}.jpg`,
      small: `/images/small/${CONTEXTO}-${NESTOR}.jpg`,
    },
    posX: 2414.82,
    posY: 1262.755,
    video: `/videos/${CONTEXTO}-${NESTOR}`,
  },
  {
    id: 28,
    category: CONTEXTO,
    artist: REYNIER_LEYVA,
    artistFull: FULL_REYNIER_LEYVA,
    images: {
      large: `/images/large/${CONTEXTO}-${REYNIER_LEYVA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${REYNIER_LEYVA}.jpg`,
      small: `/images/small/${CONTEXTO}-${REYNIER_LEYVA}.jpg`,
    },
    posX: 2798.467,
    posY: 1415.355,
    video: `/videos/${CONTEXTO}-${REYNIER_LEYVA}`,
  },
  {
    id: 29,
    category: CONTEXTO,
    artist: RODOLFO_PERAZA,
    artistFull: FULL_RODOLFO_PERAZA,
    images: {
      large: `/images/large/${CONTEXTO}-${RODOLFO_PERAZA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${RODOLFO_PERAZA}.jpg`,
      small: `/images/small/${CONTEXTO}-${RODOLFO_PERAZA}.jpg`,
    },
    posX: 2463.18,
    posY: 1432.297,
    video: `/videos/${CONTEXTO}-${RODOLFO_PERAZA}`,
  },
  {
    id: 30,
    category: CONTEXTO,
    artist: SANDRA_CEBALLOS,
    artistFull: FULL_SANDRA_CEBALLOS,
    images: {
      large: `/images/large/${CONTEXTO}-${SANDRA_CEBALLOS}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${SANDRA_CEBALLOS}.jpg`,
      small: `/images/small/${CONTEXTO}-${SANDRA_CEBALLOS}.jpg`,
    },
    posX: 1755.232,
    posY: 1014.591,
    video: `/videos/${CONTEXTO}-${SANDRA_CEBALLOS}`,
  },
  {
    id: 31,
    category: CONTEXTO,
    artist: SANDRA_RAMOS,
    artistFull: FULL_SANDRA_RAMOS,
    images: {
      large: `/images/large/${CONTEXTO}-${SANDRA_RAMOS}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${SANDRA_RAMOS}.jpg`,
      small: `/images/small/${CONTEXTO}-${SANDRA_RAMOS}.jpg`,
    },
    posX: 1665.611,
    posY: 1027.882,
    video: `/videos/${CONTEXTO}-${SANDRA_RAMOS}`,
  },
  {
    id: 32,
    category: CONTEXTO,
    artist: TANYA,
    artistFull: FULL_TANYA,
    images: {
      large: `/images/large/${CONTEXTO}-${TANYA}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${TANYA}.jpg`,
      small: `/images/small/${CONTEXTO}-${TANYA}.jpg`,
    },
    posX: 1937.111,
    posY: 1224.654,
    video: `/videos/${CONTEXTO}-${TANYA}`,
  },
  {
    id: 33,
    category: CONTEXTO,
    artist: TOIRAC,
    artistFull: FULL_TOIRAC,
    images: {
      large: `/images/large/${CONTEXTO}-${TOIRAC}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${TOIRAC}.jpg`,
      small: `/images/small/${CONTEXTO}-${TOIRAC}.jpg`,
    },
    posX: 1779.015,
    posY: 940.81,
    video: `/videos/${CONTEXTO}-${TOIRAC}`,
  },
  {
    id: 34,
    category: CONTEXTO,
    artist: YANELIS,
    artistFull: FULL_YANELIS,
    images: {
      large: `/images/large/${CONTEXTO}-${YANELIS}.jpg`,
      medium: `/images/medium/${CONTEXTO}-${YANELIS}.jpg`,
      small: `/images/small/${CONTEXTO}-${YANELIS}.jpg`,
    },
    posX: 2685.072,
    posY: 1444.414,
    video: `/videos/${CONTEXTO}-${YANELIS}`,
  },
  {
    id: 35,
    category: FORMACION,
    artist: ABEL,
    artistFull: FULL_ABEL,
    images: {
      large: `/images/large/${FORMACION}-${ABEL}.jpg`,
      medium: `/images/medium/${FORMACION}-${ABEL}.jpg`,
      small: `/images/small/${FORMACION}-${ABEL}.jpg`,
    },
    posX: 2363.316,
    posY: 1200.142,
    video: `/videos/${FORMACION}-${ABEL}`,
  },
  {
    id: 36,
    category: FORMACION,
    artist: CELIA_YUNIOR,
    artistFull: FULL_CELIA_YUNIOR,
    images: {
      large: `/images/large/${FORMACION}-${CELIA_YUNIOR}.jpg`,
      medium: `/images/medium/${FORMACION}-${CELIA_YUNIOR}.jpg`,
      small: `/images/small/${FORMACION}-${CELIA_YUNIOR}.jpg`,
    },
    posX: 2130.214,
    posY: 1069.362,
    video: `/videos/${FORMACION}-${CELIA_YUNIOR}`,
  },
  {
    id: 37,
    category: FORMACION,
    artist: FIDEL_GARCIA,
    artistFull: FULL_FIDEL_GARCIA,
    images: {
      large: `/images/large/${FORMACION}-${FIDEL_GARCIA}.jpg`,
      medium: `/images/medium/${FORMACION}-${FIDEL_GARCIA}.jpg`,
      small: `/images/small/${FORMACION}-${FIDEL_GARCIA}.jpg`,
    },
    posX: 2891.733,
    posY: 1374.605,
    video: `/videos/${FORMACION}-${FIDEL_GARCIA}`,
  },
  {
    id: 38,
    category: FORMACION,
    artist: HENRI_ERIC,
    artistFull: FULL_HENRI_ERIC,
    images: {
      large: `/images/large/${FORMACION}-${HENRI_ERIC}.jpg`,
      medium: `/images/medium/${FORMACION}-${HENRI_ERIC}.jpg`,
      small: `/images/small/${FORMACION}-${HENRI_ERIC}.jpg`,
    },
    posX: 1832.783,
    posY: 1073.822,
    video: `/videos/${FORMACION}-${HENRI_ERIC}`,
  },
  {
    id: 39,
    category: FORMACION,
    artist: HUMBERTO_DIAZ,
    artistFull: FULL_HUMBERTO_DIAZ,
    images: {
      large: `/images/large/${FORMACION}-${HUMBERTO_DIAZ}.jpg`,
      medium: `/images/medium/${FORMACION}-${HUMBERTO_DIAZ}.jpg`,
      small: `/images/small/${FORMACION}-${HUMBERTO_DIAZ}.jpg`,
    },
    posX: 1579.384,
    posY: 937.192,
    video: `/videos/${FORMACION}-${HUMBERTO_DIAZ}`,
  },
  {
    id: 40,
    category: FORMACION,
    artist: JAVIER_CASTRO,
    artistFull: FULL_JAVIER_CASTRO,
    images: {
      large: `/images/large/${FORMACION}-${JAVIER_CASTRO}.jpg`,
      medium: `/images/medium/${FORMACION}-${JAVIER_CASTRO}.jpg`,
      small: `/images/small/${FORMACION}-${JAVIER_CASTRO}.jpg`,
    },
    posX: 2658.462,
    posY: 1661.206,
    video: `/videos/${FORMACION}-${JAVIER_CASTRO}`,
  },
  {
    id: 41,
    category: FORMACION,
    artist: JORGE_RODRIGUEZ,
    artistFull: FULL_JORGE_RODRIGUEZ,
    images: {
      large: `/images/large/${FORMACION}-${JORGE_RODRIGUEZ}.jpg`,
      medium: `/images/medium/${FORMACION}-${JORGE_RODRIGUEZ}.jpg`,
      small: `/images/small/${FORMACION}-${JORGE_RODRIGUEZ}.jpg`,
    },
    posX: 3230.672,
    posY: 1470.524,
    video: `/videos/${FORMACION}-${JORGE_RODRIGUEZ}`,
  },
  {
    id: 42,
    category: FORMACION,
    artist: LUIS_MANUEL,
    artistFull: FULL_LUIS_MANUEL,
    images: {
      large: `/images/large/${FORMACION}-${LUIS_MANUEL}.jpg`,
      medium: `/images/medium/${FORMACION}-${LUIS_MANUEL}.jpg`,
      small: `/images/small/${FORMACION}-${LUIS_MANUEL}.jpg`,
    },
    posX: 2752.505,
    posY: 1609.496,
    video: `/videos/${FORMACION}-${LUIS_MANUEL}`,
  },
  {
    id: 43,
    category: FORMACION,
    artist: MAGALY_ESPINOSA,
    artistFull: FULL_MAGALY_ESPINOSA,
    images: {
      large: `/images/large/${FORMACION}-${MAGALY_ESPINOSA}.jpg`,
      medium: `/images/medium/${FORMACION}-${MAGALY_ESPINOSA}.jpg`,
      small: `/images/small/${FORMACION}-${MAGALY_ESPINOSA}.jpg`,
    },
    posX: 1486.84,
    posY: 1077.422,
    video: `/videos/${FORMACION}-${MAGALY_ESPINOSA}`,
  },
  {
    id: 44,
    category: FORMACION,
    artist: MOSQUERA,
    artistFull: FULL_MOSQUERA,
    images: {
      large: `/images/large/${FORMACION}-${MOSQUERA}.jpg`,
      medium: `/images/medium/${FORMACION}-${MOSQUERA}.jpg`,
      small: `/images/small/${FORMACION}-${MOSQUERA}.jpg`,
    },
    posX: 1266.446,
    posY: 864.86,
    video: `/videos/${FORMACION}-${MOSQUERA}`,
  },
  {
    id: 45,
    category: FORMACION,
    artist: NESTOR,
    artistFull: FULL_NESTOR,
    images: {
      large: `/images/large/${FORMACION}-${NESTOR}.jpg`,
      medium: `/images/medium/${FORMACION}-${NESTOR}.jpg`,
      small: `/images/small/${FORMACION}-${NESTOR}.jpg`,
    },
    posX: 2311.001,
    posY: 1332.365,
    video: `/videos/${FORMACION}-${NESTOR}`,
  },
  {
    id: 46,
    category: FORMACION,
    artist: REYNIER_LEYVA,
    artistFull: FULL_REYNIER_LEYVA,
    images: {
      large: `/images/large/${FORMACION}-${REYNIER_LEYVA}.jpg`,
      medium: `/images/medium/${FORMACION}-${REYNIER_LEYVA}.jpg`,
      small: `/images/small/${FORMACION}-${REYNIER_LEYVA}.jpg`,
    },
    posX: 1903.748,
    posY: 941.966,
    video: `/videos/${FORMACION}-${REYNIER_LEYVA}`,
  },
  {
    id: 47,
    category: FORMACION,
    artist: RODOLFO_PERAZA,
    artistFull: FULL_RODOLFO_PERAZA,
    images: {
      large: `/images/large/${FORMACION}-${RODOLFO_PERAZA}.jpg`,
      medium: `/images/medium/${FORMACION}-${RODOLFO_PERAZA}.jpg`,
      small: `/images/small/${FORMACION}-${RODOLFO_PERAZA}.jpg`,
    },
    posX: 3027.661,
    posY: 1469.445,
    video: `/videos/${FORMACION}-${RODOLFO_PERAZA}`,
  },
  {
    id: 48,
    category: FORMACION,
    artist: SANDRA_RAMOS,
    artistFull: FULL_SANDRA_RAMOS,
    images: {
      large: `/images/large/${FORMACION}-${SANDRA_RAMOS}.jpg`,
      medium: `/images/medium/${FORMACION}-${SANDRA_RAMOS}.jpg`,
      small: `/images/small/${FORMACION}-${SANDRA_RAMOS}.jpg`,
    },
    posX: 2077.988,
    posY: 1119.854,
    video: `/videos/${FORMACION}-${SANDRA_RAMOS}`,
  },
  {
    id: 49,
    category: FORMACION,
    artist: TANYA,
    artistFull: FULL_TANYA,
    images: {
      large: `/images/large/${FORMACION}-${TANYA}.jpg`,
      medium: `/images/medium/${FORMACION}-${TANYA}.jpg`,
      small: `/images/small/${FORMACION}-${TANYA}.jpg`,
    },
    posX: 1300.899,
    posY: 941.978,
    video: `/videos/${FORMACION}-${TANYA}`,
  },
  {
    id: 50,
    category: FORMACION,
    artist: YANELIS,
    artistFull: FULL_YANELIS,
    images: {
      large: `/images/large/${FORMACION}-${YANELIS}.jpg`,
      medium: `/images/medium/${FORMACION}-${YANELIS}.jpg`,
      small: `/images/small/${FORMACION}-${YANELIS}.jpg`,
    },
    posX: 1650.816,
    posY: 897.378,
    video: `/videos/${FORMACION}-${YANELIS}`,
  },
  {
    id: 51,
    category: MERCADO,
    artist: ABEL,
    artistFull: FULL_ABEL,
    images: {
      large: `/images/large/${MERCADO}-${ABEL}.jpg`,
      medium: `/images/medium/${MERCADO}-${ABEL}.jpg`,
      small: `/images/small/${MERCADO}-${ABEL}.jpg`,
    },
    posX: 2947.204,
    posY: 1435.311,
    video: `/videos/${MERCADO}-${ABEL}`,
  },
  {
    id: 52,
    category: MERCADO,
    artist: CELIA_YUNIOR,
    artistFull: FULL_CELIA_YUNIOR,
    images: {
      large: `/images/large/${MERCADO}-${CELIA_YUNIOR}.jpg`,
      medium: `/images/medium/${MERCADO}-${CELIA_YUNIOR}.jpg`,
      small: `/images/small/${MERCADO}-${CELIA_YUNIOR}.jpg`,
    },
    posX: 2776.173,
    posY: 1335.364,
    video: `/videos/${MERCADO}-${CELIA_YUNIOR}`,
  },
  {
    id: 53,
    category: MERCADO,
    artist: CRISTINA,
    artistFull: FULL_CRISTINA,
    images: {
      large: `/images/large/${MERCADO}-${CRISTINA}.jpg`,
      medium: `/images/medium/${MERCADO}-${CRISTINA}.jpg`,
      small: `/images/small/${MERCADO}-${CRISTINA}.jpg`,
    },
    posX: 2715.024,
    posY: 1522.154,
    video: `/videos/${MERCADO}-${CRISTINA}`,
  },
  {
    id: 54,
    category: MERCADO,
    artist: FIDEL_GARCIA,
    artistFull: FULL_FIDEL_GARCIA,
    images: {
      large: `/images/large/${MERCADO}-${FIDEL_GARCIA}.jpg`,
      medium: `/images/medium/${MERCADO}-${FIDEL_GARCIA}.jpg`,
      small: `/images/small/${MERCADO}-${FIDEL_GARCIA}.jpg`,
    },
    posX: 1906.352,
    posY: 1097.027,
    video: `/videos/${MERCADO}-${FIDEL_GARCIA}`,
  },
  {
    id: 55,
    category: MERCADO,
    artist: HUMBERTO_DIAZ,
    artistFull: FULL_HUMBERTO_DIAZ,
    images: {
      large: `/images/large/${MERCADO}-${HUMBERTO_DIAZ}.jpg`,
      medium: `/images/medium/${MERCADO}-${HUMBERTO_DIAZ}.jpg`,
      small: `/images/small/${MERCADO}-${HUMBERTO_DIAZ}.jpg`,
    },
    posX: 1360.568,
    posY: 830.332,
    video: `/videos/${MERCADO}-${HUMBERTO_DIAZ}`,
  },
  {
    id: 56,
    category: MERCADO,
    artist: JAVIER_CASTRO,
    artistFull: FULL_JAVIER_CASTRO,
    images: {
      large: `/images/large/${MERCADO}-${JAVIER_CASTRO}.jpg`,
      medium: `/images/medium/${MERCADO}-${JAVIER_CASTRO}.jpg`,
      small: `/images/small/${MERCADO}-${JAVIER_CASTRO}.jpg`,
    },
    posX: 1672.682,
    posY: 966.313,
    video: `/videos/${MERCADO}-${JAVIER_CASTRO}`,
  },
  {
    id: 57,
    category: MERCADO,
    artist: LUIS_MANUEL,
    artistFull: FULL_LUIS_MANUEL,
    images: {
      large: `/images/large/${MERCADO}-${LUIS_MANUEL}.jpg`,
      medium: `/images/medium/${MERCADO}-${LUIS_MANUEL}.jpg`,
      small: `/images/small/${MERCADO}-${LUIS_MANUEL}.jpg`,
    },
    posX: 2990.917,
    posY: 1533.196,
    video: `/videos/${MERCADO}-${LUIS_MANUEL}`,
  },
  {
    id: 58,
    category: MERCADO,
    artist: MAGALY_ESPINOSA,
    artistFull: FULL_MAGALY_ESPINOSA,
    images: {
      large: `/images/large/${MERCADO}-${MAGALY_ESPINOSA}.jpg`,
      medium: `/images/medium/${MERCADO}-${MAGALY_ESPINOSA}.jpg`,
      small: `/images/small/${MERCADO}-${MAGALY_ESPINOSA}.jpg`,
    },
    posX: 1116.999,
    posY: 1025.943,
    video: `/videos/${MERCADO}-${MAGALY_ESPINOSA}`,
  },
  {
    id: 59,
    category: MERCADO,
    artist: MOSQUERA,
    artistFull: FULL_MOSQUERA,
    images: {
      large: `/images/large/${MERCADO}-${MOSQUERA}.jpg`,
      medium: `/images/medium/${MERCADO}-${MOSQUERA}.jpg`,
      small: `/images/small/${MERCADO}-${MOSQUERA}.jpg`,
    },
    posX: 2577.489,
    posY: 1308.638,
    video: `/videos/${MERCADO}-${MOSQUERA}`,
  },
  {
    id: 60,
    category: MERCADO,
    artist: RODOLFO_PERAZA,
    artistFull: FULL_RODOLFO_PERAZA,
    images: {
      large: `/images/large/${MERCADO}-${RODOLFO_PERAZA}.jpg`,
      medium: `/images/medium/${MERCADO}-${RODOLFO_PERAZA}.jpg`,
      small: `/images/small/${MERCADO}-${RODOLFO_PERAZA}.jpg`,
    },
    posX: 2055.687,
    posY: 1217.018,
    video: `/videos/${MERCADO}-${RODOLFO_PERAZA}`,
  },
  {
    id: 61,
    category: MERCADO,
    artist: SANDRA_CEBALLOS,
    artistFull: FULL_SANDRA_CEBALLOS,
    images: {
      large: `/images/large/${MERCADO}-${SANDRA_CEBALLOS}.jpg`,
      medium: `/images/medium/${MERCADO}-${SANDRA_CEBALLOS}.jpg`,
      small: `/images/small/${MERCADO}-${SANDRA_CEBALLOS}.jpg`,
    },
    posX: 2827.214,
    posY: 1561.801,
    video: `/videos/${MERCADO}-${SANDRA_CEBALLOS}`,
  },
  {
    id: 62,
    category: MERCADO,
    artist: SANDRA_RAMOS,
    artistFull: FULL_SANDRA_RAMOS,
    images: {
      large: `/images/large/${MERCADO}-${SANDRA_RAMOS}.jpg`,
      medium: `/images/medium/${MERCADO}-${SANDRA_RAMOS}.jpg`,
      small: `/images/small/${MERCADO}-${SANDRA_RAMOS}.jpg`,
    },
    posX: 2398.989,
    posY: 1377.746,
    video: `/videos/${MERCADO}-${SANDRA_RAMOS}`,
  },
  {
    id: 63,
    category: MERCADO,
    artist: TANYA,
    artistFull: FULL_TANYA,
    images: {
      large: `/images/large/${MERCADO}-${TANYA}.jpg`,
      medium: `/images/medium/${MERCADO}-${TANYA}.jpg`,
      small: `/images/small/${MERCADO}-${TANYA}.jpg`,
    },
    posX: 1540.491,
    posY: 813.879,
    video: `/videos/${MERCADO}-${TANYA}`,
  },
  {
    id: 64,
    category: MERCADO,
    artist: TOIRAC,
    artistFull: FULL_TOIRAC,
    images: {
      large: `/images/large/${MERCADO}-${TOIRAC}.jpg`,
      medium: `/images/medium/${MERCADO}-${TOIRAC}.jpg`,
      small: `/images/small/${MERCADO}-${TOIRAC}.jpg`,
    },
    posX: 1143.276,
    posY: 876.896,
    video: `/videos/${MERCADO}-${TOIRAC}`,
  },
  {
    id: 65,
    category: MERCADO,
    artist: YANELIS,
    artistFull: FULL_YANELIS,
    images: {
      large: `/images/large/${MERCADO}-${YANELIS}.jpg`,
      medium: `/images/medium/${MERCADO}-${YANELIS}.jpg`,
      small: `/images/small/${MERCADO}-${YANELIS}.jpg`,
    },
    posX: 2484.675,
    posY: 1337.187,
    video: `/videos/${MERCADO}-${YANELIS}`,
  },
  {
    id: 66,
    category: OBRA,
    artist: ABEL,
    artistFull: FULL_ABEL,
    images: {
      large: `/images/large/${OBRA}-${ABEL}.jpg`,
      medium: `/images/medium/${OBRA}-${ABEL}.jpg`,
      small: `/images/small/${OBRA}-${ABEL}.jpg`,
    },
    posX: 1005.208,
    posY: 982.991,
    video: `/videos/${OBRA}-${ABEL}`,
  },
  {
    id: 67,
    category: OBRA,
    artist: CELIA_YUNIOR,
    artistFull: FULL_CELIA_YUNIOR,
    images: {
      large: `/images/large/${OBRA}-${CELIA_YUNIOR}.jpg`,
      medium: `/images/medium/${OBRA}-${CELIA_YUNIOR}.jpg`,
      small: `/images/small/${OBRA}-${CELIA_YUNIOR}.jpg`,
    },
    posX: 2179.712,
    posY: 1124.271,
    video: `/videos/${OBRA}-${CELIA_YUNIOR}`,
  },
  {
    id: 68,
    category: OBRA,
    artist: CRISTINA,
    artistFull: FULL_CRISTINA,
    images: {
      large: `/images/large/${OBRA}-${CRISTINA}.jpg`,
      medium: `/images/medium/${OBRA}-${CRISTINA}.jpg`,
      small: `/images/small/${OBRA}-${CRISTINA}.jpg`,
    },
    posX: 3082.333,
    posY: 1539.841,
    video: `/videos/${OBRA}-${CRISTINA}`,
  },
  {
    id: 69,
    category: OBRA,
    artist: FIDEL_GARCIA,
    artistFull: FULL_FIDEL_GARCIA,
    images: {
      large: `/images/large/${OBRA}-${FIDEL_GARCIA}.jpg`,
      medium: `/images/medium/${OBRA}-${FIDEL_GARCIA}.jpg`,
      small: `/images/small/${OBRA}-${FIDEL_GARCIA}.jpg`,
    },
    posX: 2622.387,
    posY: 1580.184,
    video: `/videos/${OBRA}-${FIDEL_GARCIA}`,
  },
  {
    id: 70,
    category: OBRA,
    artist: HENRI_ERIC,
    artistFull: FULL_HENRI_ERIC,
    images: {
      large: `/images/large/${OBRA}-${HENRI_ERIC}.jpg`,
      medium: `/images/medium/${OBRA}-${HENRI_ERIC}.jpg`,
      small: `/images/small/${OBRA}-${HENRI_ERIC}.jpg`,
    },
    posX: 1377.536,
    posY: 890.424,
    video: `/videos/${OBRA}-${HENRI_ERIC}`,
  },
  {
    id: 71,
    category: OBRA,
    artist: HUMBERTO_DIAZ,
    artistFull: FULL_HUMBERTO_DIAZ,
    images: {
      large: `/images/large/${OBRA}-${HUMBERTO_DIAZ}.jpg`,
      medium: `/images/medium/${OBRA}-${HUMBERTO_DIAZ}.jpg`,
      small: `/images/small/${OBRA}-${HUMBERTO_DIAZ}.jpg`,
    },
    posX: 1028.95,
    posY: 905.393,
    video: `/videos/${OBRA}-${HUMBERTO_DIAZ}`,
  },
  {
    id: 72,
    category: OBRA,
    artist: JAVIER_CASTRO,
    artistFull: FULL_JAVIER_CASTRO,
    images: {
      large: `/images/large/${OBRA}-${JAVIER_CASTRO}.jpg`,
      medium: `/images/medium/${OBRA}-${JAVIER_CASTRO}.jpg`,
      small: `/images/small/${OBRA}-${JAVIER_CASTRO}.jpg`,
    },
    posX: 811.447,
    posY: 1025.871,
    video: `/videos/${OBRA}-${JAVIER_CASTRO}`,
  },
  {
    id: 73,
    category: OBRA,
    artist: JORGE_RODRIGUEZ,
    artistFull: FULL_JORGE_RODRIGUEZ,
    images: {
      large: `/images/large/${OBRA}-${JORGE_RODRIGUEZ}.jpg`,
      medium: `/images/medium/${OBRA}-${JORGE_RODRIGUEZ}.jpg`,
      small: `/images/small/${OBRA}-${JORGE_RODRIGUEZ}.jpg`,
    },
    posX: 2611.759,
    posY: 1493.276,
    video: `/videos/${OBRA}-${JORGE_RODRIGUEZ}`,
  },
  {
    id: 74,
    category: OBRA,
    artist: LUIS_MANUEL,
    artistFull: FULL_LUIS_MANUEL,
    images: {
      large: `/images/large/${OBRA}-${LUIS_MANUEL}.jpg`,
      medium: `/images/medium/${OBRA}-${LUIS_MANUEL}.jpg`,
      small: `/images/small/${OBRA}-${LUIS_MANUEL}.jpg`,
    },
    posX: 3170.364,
    posY: 1571.363,
    video: `/videos/${OBRA}-${LUIS_MANUEL}`,
  },
  {
    id: 75,
    category: OBRA,
    artist: MAGALY_ESPINOSA,
    artistFull: FULL_MAGALY_ESPINOSA,
    images: {
      large: `/images/large/${OBRA}-${MAGALY_ESPINOSA}.jpg`,
      medium: `/images/medium/${OBRA}-${MAGALY_ESPINOSA}.jpg`,
      small: `/images/small/${OBRA}-${MAGALY_ESPINOSA}.jpg`,
    },
    posX: 1969.603,
    posY: 1148.773,
    video: `/videos/${OBRA}-${MAGALY_ESPINOSA}`,
  },
  {
    id: 76,
    category: OBRA,
    artist: NESTOR,
    artistFull: FULL_NESTOR,
    images: {
      large: `/images/large/${OBRA}-${NESTOR}.jpg`,
      medium: `/images/medium/${OBRA}-${NESTOR}.jpg`,
      small: `/images/small/${OBRA}-${NESTOR}.jpg`,
    },
    posX: 3139.764,
    posY: 1478.15,
    video: `/videos/${OBRA}-${NESTOR}`,
  },
  {
    id: 77,
    category: OBRA,
    artist: REYNIER_LEYVA,
    artistFull: FULL_REYNIER_LEYVA,
    images: {
      large: `/images/large/${OBRA}-${REYNIER_LEYVA}.jpg`,
      medium: `/images/medium/${OBRA}-${REYNIER_LEYVA}.jpg`,
      small: `/images/small/${OBRA}-${REYNIER_LEYVA}.jpg`,
    },
    posX: 835.819,
    posY: 1161.893,
    video: `/videos/${OBRA}-${REYNIER_LEYVA}`,
  },
  {
    id: 78,
    category: OBRA,
    artist: RODOLFO_PERAZA,
    artistFull: FULL_RODOLFO_PERAZA,
    images: {
      large: `/images/large/${OBRA}-${RODOLFO_PERAZA}.jpg`,
      medium: `/images/medium/${OBRA}-${RODOLFO_PERAZA}.jpg`,
      small: `/images/small/${OBRA}-${RODOLFO_PERAZA}.jpg`,
    },
    posX: 2540.197,
    posY: 1677.069,
    video: `/videos/${OBRA}-${RODOLFO_PERAZA}`,
  },
  {
    id: 79,
    category: OBRA,
    artist: SANDRA_CEBALLOS,
    artistFull: FULL_SANDRA_CEBALLOS,
    images: {
      large: `/images/large/${OBRA}-${SANDRA_CEBALLOS}.jpg`,
      medium: `/images/medium/${OBRA}-${SANDRA_CEBALLOS}.jpg`,
      small: `/images/small/${OBRA}-${SANDRA_CEBALLOS}.jpg`,
    },
    posX: 1848.968,
    posY: 884.907,
    video: `/videos/${OBRA}-${SANDRA_CEBALLOS}`,
  },
  {
    id: 80,
    category: OBRA,
    artist: SANDRA_RAMOS,
    artistFull: FULL_SANDRA_RAMOS,
    images: {
      large: `/images/large/${OBRA}-${SANDRA_RAMOS}.jpg`,
      medium: `/images/medium/${OBRA}-${SANDRA_RAMOS}.jpg`,
      small: `/images/small/${OBRA}-${SANDRA_RAMOS}.jpg`,
    },
    posX: 2163.954,
    posY: 1184.531,
    video: `/videos/${OBRA}-${SANDRA_RAMOS}`,
  },
  {
    id: 81,
    category: OBRA,
    artist: TOIRAC,
    artistFull: FULL_TOIRAC,
    images: {
      large: `/images/large/${OBRA}-${TOIRAC}.jpg`,
      medium: `/images/medium/${OBRA}-${TOIRAC}.jpg`,
      small: `/images/small/${OBRA}-${TOIRAC}.jpg`,
    },
    posX: 3282.096,
    posY: 1541.648,
    video: `/videos/${OBRA}-${TOIRAC}`,
  },
  {
    id: 82,
    category: OBRA,
    artist: YANELIS,
    artistFull: FULL_YANELIS,
    images: {
      large: `/images/large/${OBRA}-${YANELIS}.jpg`,
      medium: `/images/medium/${OBRA}-${YANELIS}.jpg`,
      small: `/images/small/${OBRA}-${YANELIS}.jpg`,
    },
    posX: 2921.839,
    posY: 1590.287,
    video: `/videos/${OBRA}-${YANELIS}`,
  },
];
export default data;
